module.exports = __webpack_public_path__ + "img/2.d117fbd6.png";